<img style="top: 10px" src="/assets/img/close-modal.svg" class="modal__close" (click)="close()" />
<div style="margin-top: 4px" class="feature-not-available">
    <div>
        <div>
            <p style="font-size: 18px; text-align: left">
                {{options.message}}
            </p>
        </div>
    </div>
</div>